import * as Yup from 'yup';
import moment from 'moment';
import { getCityNameValidation, getStrictNameValidationSchema } from '../../../../../../../utils/ValidationSchema';

export default Yup.object().shape({
  company_name: getStrictNameValidationSchema({ message: 'company name', isRequired: true }),
  city: Yup.string().required(''),
  designation: getStrictNameValidationSchema({ message: 'designation', isRequired: true }),
  employee_id: Yup.string().required('Please enter a valid Employee ID'),
  // .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Please enter a valid Employee ID'),
  start_date: Yup.mixed().test({
    name: 'start_date',
    message: 'Please enter a valid date',
    test: (value) => {
      if (value !== null) {
        return moment(value).isValid();
      } else {
        return false;
      }
    }
  }),
  end_date: Yup.mixed().when('currently_working', {
    is: false,
    then: Yup.mixed().test({
      name: 'end_date',
      message: 'Please enter a valid date',
      test: (value) => {
        if (value !== null) {
          return moment(value).isValid();
        } else {
          return false;
        }
      }
    })
  })
});
